import React from 'react'
import PropTypes from 'prop-types'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { MdRefresh } from 'react-icons/md'
import Typography from '../Typography/index'

const Pagination = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
  onRefresh,
  justify = 'center', // 'start', 'center', 'end'
}) => {
  const justifyClass = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
  }[justify]

  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage + 1
  const endIndex = Math.min(currentPage * itemsPerPage, totalItems)

  return (
    <div className={`flex items-center gap-6 mt-4 ${justifyClass}`}>
      <div onClick={onRefresh}>
        <div className="p-2 border rounded-full border-primary cursor-pointer">
          <MdRefresh />
        </div>
      </div>

      <div className="flex items-center">
        <Typography className="text-secondary">
          {`${startIndex}-${endIndex} of `}
          <span className="text-primary px-2">{totalItems}</span>
        </Typography>
      </div>

      <div className="flex gap-4 p-2">
        <button
          className="disabled:opacity-30"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <IoIosArrowBack className="text-2xl" />
        </button>
        <button
          className="disabled:opacity-30"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
        >
          <IoIosArrowForward className="text-2xl" />
        </button>
      </div>
    </div>
  )
}

export default Pagination

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  justify: PropTypes.string,
}
